import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './stats3.css'

const Stats3 = (props) => {
  const stats = [
    { value: props.stat1, desc: props.stat1Description, defaultVal: '99%',  defaultDesc: 'Customer satisfaction' },
    { value: props.stat2, desc: props.stat2Description, defaultVal: '< 5min', defaultDesc: 'Average approval time' },
    { value: props.stat3, desc: props.stat3Description, defaultVal: 'R8 000', defaultDesc: 'Max loan amount' },
    { value: props.stat4, desc: props.stat4Description, defaultVal: '6 months', defaultDesc: 'Flexible repayment' },
  ]

  return (
    <section className="stats3-section thq-section-padding">
      <div className="stats3-thq-max-width-elm thq-section-max-width">
        <div className="stats3-container2">
          <h2 className="thq-heading-2 stats3-thq-title-elm">
            {props.heading1 ?? <Fragment><span className="stats3-text27">Fast Approval</span></Fragment>}
          </h2>
          <span className="thq-body-small">
            {props.content1 ?? <Fragment><span className="stats3-text18">Get access to funds quickly with our instant approval process.</span></Fragment>}
          </span>
        </div>
        <div className="stats3-container3">
          {stats.map((s, i) => (
            <div key={i} className="stats3-stat">
              <h2 className="thq-heading-2">
                {s.value ?? <span>{s.defaultVal}</span>}
              </h2>
              <span className="thq-body-small">
                {s.desc ?? <span>{s.defaultDesc}</span>}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

Stats3.defaultProps = {
  content1: undefined, stat4Description: undefined, stat1Description: undefined,
  stat3Description: undefined, stat1: undefined, stat2: undefined,
  stat2Description: undefined, stat4: undefined, stat3: undefined, heading1: undefined,
}
Stats3.propTypes = {
  content1: PropTypes.element, stat4Description: PropTypes.element,
  stat1Description: PropTypes.element, stat3Description: PropTypes.element,
  stat1: PropTypes.element, stat2: PropTypes.element, stat2Description: PropTypes.element,
  stat4: PropTypes.element, stat3: PropTypes.element, heading1: PropTypes.element,
}

export default Stats3
